import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MainRange from '../../../MUI/MainRange';
import useDeviceResize from '../../../../hooks/useDeviceResize';

const OncoCareRisks = ({
  riskAmount,
  setRiskAmount,
  riskAmounts,
}) => {
  const { t } = useTranslation();
  const isDeviceMobileSize = useDeviceResize('sm');

  const parsedValues = useMemo(() => riskAmounts.map(
    (value) => parseInt(value, 10),
  ), [riskAmounts]);
  const step = parsedValues[1] - parsedValues[0];
  const min = Math.min(...parsedValues);
  const max = Math.max(...parsedValues);

  const marks = useMemo(() => riskAmounts.map((value, index) => ({
    value: parseInt(value, 10),
    label: (!isDeviceMobileSize || (index === 0 || index === riskAmounts.length - 1)) ? `֏ ${parseInt(value, 10) / 1000000} ${t('oncoCareCalculator.mln')}` : '',
    mobileLabel: (!isDeviceMobileSize || (index === 0 || index === riskAmounts.length - 1)) ? `֏ ${parseInt(value, 10) / 1000000} ${t('oncoCareCalculator.million')}` : '',
  })),
  [isDeviceMobileSize, riskAmounts, t]);

  return (
    <MainRange
      step={step}
      marks={marks}
      min={min}
      max={max}
      values={riskAmount}
      setValues={setRiskAmount}
    />
  );
};

OncoCareRisks.propTypes = {
  riskAmount: PropTypes.arrayOf(PropTypes.number).isRequired,
  setRiskAmount: PropTypes.func.isRequired,
  riskAmounts: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OncoCareRisks;
